<template>
  <div class="container">
    <h1>Billing Status</h1>
    <div id="outbox-content">
      <div id="billrun">
        <div class="billrun-table table table--responsive table--highlight">
          <div class="table_wrapper">
            <h3 class="int-green margin-bottom-1">Successfull Bill Periods <span
                style="font-size: x-small">max 10</span></h3>
            <table data-init="auto" class="margin-bottom-4">
              <thead>
              <tr>
                <th class="table-header">Period</th>
                <th class="table-header">Number of customers</th>
                <th class="table-header">Number of bill items</th>
                <th class="table-header">Success</th>
                <th class="table-header">Info Text</th>
                <th class="table-header">Updated On</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in billRunSuccess" :key="item.periode">
                <td>{{ convertPeriodToDate(item.periode) }}</td>
                <td>{{ item.customers }}</td>
                <td>{{ item.billings }}</td>
                <td>{{ item.success ? 'Yes' : 'No' }}</td>
                <td>
                  <sdx-dialog
                      notification-type="general"
                      label="BillRun Log"
                      type="closable-modal"
                  >
                    <sdx-dialog-toggle>
                      <sdx-button theme="transparent" id="notification-modal-opener1" label="See more"></sdx-button>
                    </sdx-dialog-toggle>
                    <sdx-dialog-content>
                      <p class="text-align-left margin-bottom-4 code text-smaller"
                         v-html="prepareInfoForOutput(item.info)"></p>
                    </sdx-dialog-content>
                  </sdx-dialog>
                </td>
                <td :title="'Created: ' + formatDate(item.createdOn)">{{ formatDate(item.updatedOn) }}</td>
              </tr>
              </tbody>
            </table>
            <h3 class="int-red margin-bottom-1">Failed Bill Periods <span style="font-size: x-small">max 20</span></h3>
            <table>
              <thead>
              <tr>
                <th class="table-header">Period</th>
                <th class="table-header">Number of customers</th>
                <th class="table-header">Number of bill items</th>
                <th class="table-header">Success</th>
                <th class="table-header">Info Text</th>
                <th class="table-header">Updated On</th>
                <th class="table-header">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in billRunsFailed" :key="item.periode">
                <td>{{ convertPeriodToDate(item.periode) }}</td>
                <td>{{ item.customers }}</td>
                <td>{{ item.billings }}</td>
                <td>{{ item.success ? 'Yes' : 'No' }}</td>
                <td>
                  <sdx-dialog
                      notification-type="general"
                      label="BillRun Log"
                      type="closable-modal"
                      display-change-callback="
                if (arguments[0] === 'closing') document.querySelector('#notification-modal-opener1').doFocus();
              "
                  >
                    <sdx-dialog-toggle>
                      <sdx-button theme="transparent" id="notification-modal-opener1" label="See more"></sdx-button>
                    </sdx-dialog-toggle>
                    <sdx-dialog-content class="text-align-center">
                      <p class="text-align-left margin-bottom-4 code text-smaller"
                         v-html="prepareInfoForOutput(item.info)"></p>
                    </sdx-dialog-content>
                  </sdx-dialog>
                </td>
                <td :title="'Created: ' + formatDate(item.createdOn)">{{ formatDate(item.updatedOn) }}</td>
                <td>
                  <sdx-dialog
                      notification-type="general"
                      label="BillRun Log"
                      type="closable-modal"
                      display-change-callback="
                if (arguments[0] === 'closing') document.querySelector('#notification-modal-openerActual').doFocus();
              "
                  >
                    <sdx-dialog-toggle>
                      <sdx-button theme="transparent" id="notification-modal-openerActual"
                                  title="Run BillRun for this period." icon-name="icon-play"
                                  @click="runBillRun(item.periode);"></sdx-button>
                    </sdx-dialog-toggle>
                    <sdx-dialog-content class="text-align-center">
                      <p class="text-align-left margin-bottom-4 code text-smaller"
                         v-html="prepareInfoForOutput(billRunActual)"></p>
                    </sdx-dialog-content>
                  </sdx-dialog>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row justify-content-between">
        <div class="col-xs">
          <div v-if="totalPages != 1" class="billrun-pagination">
            <div :current-page="currentPage.number + 1" :total-pages="Math.ceil(totalElements / size)"
                 @pageChanged="search">
              <ul v-if="totalPages > 0" class="pagination">
                <li class="pagination-item">
                  <sdx-button id="firstPage" type="button" label="<<" class="sdx-button"
                              @click="gotoPage(1)" :disabled="isFirstPage"/>
                </li>
                <li class="pagination-item">
                  <sdx-button id="onePageBackwards" type="button" label="<" class="sdx-button"
                              @click="gotoPage(currentPage - 1)" :disabled="isFirstPage"/>
                </li>
                <li v-for="page in pages" :key="page.pageNumber" class="pagination-item">
                  <span v-if="page.placeholder" class="pagination-button inactive">...</span>
                  <button v-else type="button" class="pagination-button"
                          @click="gotoPage(page.pageNumber)"
                          :class="page.currentPage ? 'active' : 'inactive'">
                    {{ page.pageNumber }}
                  </button>
                </li>
                <li class="pagination-item">
                  <sdx-button id="nextPage" type="button" label=">" class="sdx-button"
                              @click="gotoPage(currentPage + 1)" :disabled="isLastPage"/>
                </li>
                <li class="pagination-item">
                  <sdx-button id="lastPage" type="button" label=">>" class="sdx-button"
                              @click="gotoPage(totalPages)" :disabled="isLastPage"/>
                </li>
                <li class="pagination-item total-elements">Total: {{ totalElements }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {logger} from "@/services/logger.service";
import billrunService from "../service"
import envService from "@/services/env.service";
import {showAlert} from "@/services/notification.service";
import {formatDate} from "@/util/utility";

export default {
  components: {},
  data: function () {
    return {
      webId: undefined,
      totalPages: -1,
      pageNumber: -1,
      currentPage: -1,
      totalElements: -1,
      size: -1,
      page: [],
      showBillrunStatus: false,
      delay: 1000,
      loadingData: false,
      lastLoad: '',
      period: undefined,
      billRunSuccess: [],
      billRunsFailed: [],
      billRunActual: "Running..."
    }
  },
  computed: {
    envService() {
      return envService
    },
    pages: function () {
      let previousPage = this.currentPage > 1 ? (this.currentPage - 1) : 1
      let nextPage = this.currentPage < this.totalPages ? (this.currentPage + 1) : this.totalPages
      let extraPreviousPage = previousPage === 3 ? 2 : null
      let extraNextPage = nextPage === (this.totalPages - 2) ? (this.totalPages - 1) : null
      let placeholderBefore = previousPage > 3 ? 2 : null
      let placeholderAfter = nextPage < (this.totalPages - 2) ? (this.totalPages - 1) : null
      let pages = []

      for (let i = 1; i <= this.totalPages; i += 1) {
        if ([1, this.totalPages, this.currentPage, previousPage, nextPage, extraPreviousPage, extraNextPage, placeholderBefore, placeholderAfter].includes(i)) {
          pages.push({
            pageNumber: i,
            currentPage: this.currentPage === i,
            placeholder: [placeholderBefore, placeholderAfter].includes(i)
          })
        }
      }
      return pages
    },
    isFirstPage: function () {
      return this.currentPage === 1
    },
    isLastPage: function () {
      return this.currentPage === this.totalPages
    },

  },
  mounted() {
    logger.debug("mounted")
    this.loadData();
  },
  methods: {
    formatDate,
    async loadData() {

      this.showBillrunStatus = true;
      logger.debug('Fail')

      try {
        let responseSuccess = await billrunService.getSuccessfullBillPeriod()
        this.billRunSuccess = responseSuccess.data;
      } catch (error) {
        showAlert("Failed to load 'Last success Bill Period' " + error.message)
      }

      try {
        let responseFailed = await billrunService.getFailedBillPeriods()
        this.billRunsFailed = responseFailed.data;
      } catch (error) {
        showAlert("Failed to load 'Failed Bill Periods' " + error.message)
      }

    },
    async runBillRun(day) {
      this.billRunActual = "BillRun for period " + day + " is running..."
      logger.debug(this.billRunActual)
      let response = await billrunService.runBillRun(day);
      this.billRunActual = this.prepareInfoForOutput(response.data.info)
    },
    prepareInfoForOutput: function (info) {
      logger.debug(info)
      return (info + "")
          .replaceAll('\n   ', '<br/>&nbsp;&nbsp;&nbsp;')
          .replaceAll('\n  ', '<br/>&nbsp;&nbsp;')
          .replaceAll('\n ', '<br/>&nbsp;')
          //do not replace every single space with non-breaking space, because some errors get a too long line
          .replaceAll(/error/gi, "<span style='color:red'>ERROR</span>")
    },
    convertPeriodToDate: function (value) {
      if (!value || value.length !== 8) {
        return null;
      }

      const year = value.slice(0, 4);
      const month = value.slice(4, 6);
      const day = value.slice(6, 8);

      return `${day}.${month}.${year}`;
    }
  },
};
</script>

<style>
.billrun-table {
  padding-top: 30px;
}

.billrun-table .table-header {
  padding-top: 20px;
  padding-bottom: 17px;
}

.billrun-table .table-cell {
  padding-top: 5px;
  padding-bottom: 2px;
}

.billrun-table .table-cell {
  border-radius: 20px;
}

.billrun-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

.total-elements {
  padding: 11px 23px;
}

.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.sdx-button {
  min-width: 48px !important;
  min-height: 51px !important;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button {
  padding: 11px 23px;
  border-radius: 5px;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button.active {
  background-color: rgb(8, 106, 219);
  color: rgb(255, 255, 255);
  border: 1px solid rgb(8, 106, 219);
}

.pagination-button.inactive {
  background-color: rgb(207, 213, 217);
  color: rgb(51, 51, 51);
  border: 1px solid rgb(207, 213, 217);;
}

</style>
